export default __webpack_public_path__ + "static/fertilewinterhome1-f176dee57353ef6f62fefe41fb0a85fa.png";